import React from 'react';
import { ShieldIcon } from 'lucide-react';
export function FloatingBottomCTA() {
  return <div className="fixed bottom-0 left-0 w-full z-50" data-id="element-71">
      <div className="bg-deep-black/95 backdrop-blur-md border-t border-cyan-neon/30 px-4 py-3" data-id="element-72">
        <div className="max-w-4xl mx-auto flex items-center justify-center" data-id="element-73">
          <a href="#pricing" className="btn-3d-glow px-8 py-4 text-base sm:text-lg whitespace-nowrap group w-full sm:w-auto min-w-[280px]" data-id="element-74">
            ACTIVAR BLINDAJE
            <ShieldIcon className="ml-2 w-5 h-5" data-id="element-75" />
          </a>
        </div>
      </div>
    </div>;
}